<template>
    <div>
        <div class="row d-flex justify-content-end">
            <!-- <div class="col-lg-8">
                <span class="title"> {{ hierarchy ? hierarchy : "" }} </span>
                <span class="badge id" v-if="localFacility"> {{ localFacility.facilityIdx }} </span>
                <span class="badge title" v-if="localFacility && localFacility.ct"> CT: {{ localFacility.ct }} </span>
                <span class="badge option" v-if="localFacility && localFacility.mappingKey">
                    MAP: {{ localFacility.mappingKey }}
                </span>
            </div> -->
            <div class="col-lg-4">
                <div class="btn-group pull-right mb-0" style="width: 100%; display: flex; flex: 1">
                    <button class="btn btn-sm btn-white" v-if="localFacility ? true : false" @click="onTotalRealPopup">
                        <i class="fa fa-circle-notch fa-spin" style="flex: 1; vertical-align: middle"></i>
                        {{ $t("실시간 상태값") }}
                    </button>
                    <button
                        class="btn btn-sm btn-light"
                        :class="[filterIO == '' ? 'active' : '']"
                        @click="filterIO = ''"
                        style="white-space: nowrap"
                    >
                        {{ $t("전체") }} ({{ localFacilityMap.length }})
                    </button>
                    <button
                        class="btn btn-sm btn-light"
                        :class="[filterIO == 'In' ? 'active' : '']"
                        @click="filterIO = 'In'"
                        style="white-space: nowrap"
                    >
                        {{ $t("계측") }} ({{
                            localFacilityMap.filter((v) => ["In", "Both"].includes(v.direction)).length
                        }})
                    </button>
                    <button
                        class="btn btn-sm btn-light"
                        :class="[filterIO == 'Out' ? 'active' : '']"
                        @click="filterIO = 'Out'"
                        style="white-space: nowrap"
                    >
                        {{ $t("제어") }} ({{
                            localFacilityMap.filter((v) => ["Out", "Both"].includes(v.direction)).length
                        }})
                    </button>
                </div>
            </div>
        </div>

        <div class="row m-t-5 mb-2">
            <div class="col-lg-6">
                <div class="d-flex">
                    <div class="input-group m-r-5">
                        <div class="input-group-prepend">
                            <span for="searchPtAddr" class="input-group-text">관제점 주소</span>
                        </div>
                        <select v-model="filterAddr" class="form-control">
                            <option value="">{{ $t("전체") }}</option>
                            <option value="Y">{{ $t("주소있음") }}</option>
                            <option value="N">{{ $t("주소없음") }}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span for="searchPtAddr" class="input-group-text">검색어</span>
                        </div>
                        <ValidInput
                            :inputType="'text'"
                            :inputValue.sync="filterName"
                            :rules="rules.COLLECT_DATA_SEARCH_RULE"
                            :placeholder="$t('검색어를 입력하세요.')"
                            :NonStatus="true"
                        />
                    </div>
                </div>
            </div>
            <div class="col-lg-2"></div>
            <div class="col-lg-4">
                <div class="btn-group pull-right" style="width: 100%; display: flex; flex: 1">
                    <button class="btn btn-sm btn-danger" @click="onClearAddr">
                        <i class="fa fa-eraser" style="flex: 1; vertical-align: middle"></i> {{ $t("지우기") }}
                    </button>
                    <button class="btn btn-sm btn-primary" @click="onFillAddr">
                        <i class="fa fa-paw" style="flex: 1; vertical-align: middle"></i> {{ $t("자동채우기") }}
                    </button>
                    <button class="btn btn-sm btn-secondary" @click="onSaveMap">
                        <i class="fa fa-save" style="flex: 1; vertical-align: middle"></i> {{ $t("저장") }}
                    </button>
                </div>
            </div>
        </div>

        <div class="facilityMap-table-div">
            <table class="table table-hover bg-white">
                <thead class="">
                    <tr>
                        <th class="text-center bg-inverse" style="width: 5%">
                            <button class="btn btn-xs btn-yellow" @click="toggleAll">{{ $t("선택") }}</button>
                        </th>
                        <th class="text-center bg-inverse text-grey" style="width: 4%">{{ $t("번호") }}</th>
                        <th class="text-center bg-inverse text-grey" style="width: 4%">{{ $t("CT") }}</th>
                        <th class="text-center bg-inverse text-grey" style="width: 6%">{{ $t("입출력") }}</th>
                        <th class="text-center bg-inverse text-grey" style="width: 10%">{{ $t("관제속성") }}</th>
                        <th class="text-center bg-inverse text-grey" style="width: 7%">{{ $t("집계유형") }}</th>
                        <th class="text-center bg-inverse text-grey" style="width: 3%"></th>
                        <th class="text-center bg-inverse text-grey" style="width: 20%">
                            {{ $t("연결된 관제점") }}
                        </th>
                        <th class="text-center bg-inverse text-grey" style="">{{ $t("설명") }}</th>
                    </tr>
                </thead>
                <tbody v-if="localFacilityMap && localFacilityMap.length">
                    <tr
                        v-for="(property, i) in pagingMap"
                        :key="i"
                        @click="openDetailModal(property)"
                        style="cursor: pointer"
                    >
                        <td class="text-center valign-middle" @click.stop="rowSelect(property)" style="cursor: pointer">
                            <div class="checkbox checkbox-css m-l-20" style="margin-top: -6px; cursor: pointer">
                                <input
                                    type="checkbox"
                                    :id="'facilityMap_' + i"
                                    v-model="property.isChecked"
                                    style="cursor: pointer"
                                />
                                <label :for="'facilityMap_' + i"></label>
                            </div>
                        </td>
                        <td class="text-center valign-middle">{{ i + 1 + (curPage - 1) * viewSize }}</td>
                        <td class="text-center valign-middle">{{ property.ct == 0 ? "" : property.ct }}</td>
                        <td class="text-center valign-middle" style="font-size: 14px">
                            <b-badge :variant="property.direction == 'In' ? 'light' : 'secondary'" class="m-l-5">
                                {{ property.direction }}
                            </b-badge>
                        </td>
                        <td class="text-center valign-middle">
                            <b-badge variant="light" class="m-l-5"> {{ property.propName }} </b-badge>
                        </td>
                        <td class="text-center valign-middle">
                            {{
                                $store.state.commonCodes.ptTypeCode.find((type) => type.value == property.ptType)
                                    ? $store.state.commonCodes.ptTypeCode.find((type) => type.value == property.ptType)
                                          .text
                                    : "-"
                            }}
                        </td>
                        <td class="text-center valign-middle">
                            <b-badge
                                v-if="property.ptIdx"
                                variant="light"
                                :class="{ 'text-red': property.orgAddr !== property.ptAddr }"
                            >
                                <!-- <i class="fa fa-asterisk" :class="'valign-middle'"></i> -->
                            </b-badge>
                        </td>
                        <td class="text-left valign-middle p-t-0 p-b-0" style="height: 34px">
                            <drop
                                v-if="property.isChecked"
                                @dragover="handleBodyDragOver(...arguments)"
                                @drop="handleBodyDrop(...arguments)"
                            >
                                <div class="form-inline">
                                    <input
                                        v-if="property.isChecked"
                                        type="text"
                                        class="form-control addr-control"
                                        style="width: 70%"
                                        :placeholder="$t('자동채우기로 관제점 주소를 생성')"
                                        v-model="property.ptAddr"
                                        @input="onChangeAddr(property)"
                                        @change="onChangeAddr(property)"
                                        @click.stop="onInputClick"
                                    />
                                </div>
                            </drop>
                            <span v-else> {{ property.ptAddrText }} </span>
                        </td>
                        <td class="text-left valign-middle">
                            {{
                                property.remark && property.remark.includes && property.remark.includes("(") === true
                                    ? `${$t(property.remark.split("(")[0])}(${property.remark.split("(")[1]}`
                                    : property.remark
                                    ? $t(property.remark)
                                    : "-"
                            }}
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="9" class="text-center">
                            <div style="padding: 50px; color: #999">
                                {{ $t("데이터가 없습니다.") }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <hr />
        <div class="row" v-if="filterMap && filterMap.length">
            <div class="col-2">
                <select class="form-control" style="max-width: 80px" v-model="viewSize">
                    <option v-for="(size, i) in perViews" :key="i" :value="size">
                        {{ size == 99999 ? "전체" : size }}
                    </option>
                </select>
            </div>
            <div class="col-8">
                <div class="text-center">
                    <a
                        href="javascript:;"
                        class="btn btn-sm btn-default"
                        @click="
                            curPage = 1;
                            minPage = 1;
                        "
                        ><i class="fa fa-angle-double-left"></i
                    ></a>
                    <button
                        class="btn btn-sm"
                        :class="[curPage != 1 ? 'btn-white' : 'xe-btn-disable btn-default']"
                        @click="beforePage()"
                    >
                        <i class="fa fa-angle-left"></i>
                    </button>
                    <span v-for="i in maxPage" :key="i">
                        <button
                            class="btn btn-sm btn-white"
                            :class="{ active: curPage == i }"
                            v-if="i >= minPage && i <= minPage + pageSize - 1"
                            @click="curPage = i"
                        >
                            {{ i }}
                        </button>
                    </span>
                    <button
                        class="btn btn-sm"
                        :class="[curPage != maxPage ? 'btn-white' : 'xe-btn-disable btn-default']"
                        @click="nextPage()"
                    >
                        <i class="fa fa-angle-right"></i>
                    </button>
                    <button
                        class="btn btn-sm btn-default"
                        @click="
                            curPage = maxPage;
                            minPage = maxPage;
                        "
                    >
                        <i class="fa fa-angle-double-right"></i>
                    </button>
                </div>
            </div>
            <div class="col-2">
                <span class="pull-right"> {{ $t("전체건수") }} : {{ filterMap.length }} </span>
            </div>
        </div>

        <b-modal ref="detailModal" size="lg" :hide-footer="true" :title="$t('상세 정보')" id="point-mapping-container">
            <div class="detail-tabs">
                <ul class="nav nav-tabs" role="tablist">
                    <li v-if="selectedProperty?.ptIdx" class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ active: activeTab === 'point' }"
                            @click="activeTab = 'point'"
                            style="cursor: pointer"
                        >
                            <i class="fa fa-info-circle"></i> {{ $t("포인트 상세") }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ active: activeTab === 'driver' }"
                            @click="activeTab = 'driver'"
                            style="cursor: pointer"
                        >
                            <i class="fa fa-cog"></i> {{ $t("드라이버 속성") }}
                        </a>
                    </li>
                </ul>

                <div class="point-mapping-modal-tab-content">
                    <div
                        v-if="selectedProperty?.ptIdx"
                        class="tab-pane"
                        :class="{ 'show active': activeTab === 'point' }"
                        id="pointDetail"
                        role="tabpanel"
                        v-show="activeTab === 'point'"
                    >
                        <point-detail
                            ref="point-detail"
                            :title="''"
                            :ptIdx="ptIdx"
                            :noWatch="true"
                            @data-updated="dataUpdated"
                            @closed="closeDetailModal"
                        />
                    </div>
                    <div
                        class="tab-pane"
                        :class="{ 'show active': activeTab === 'driver' }"
                        id="driverDetail"
                        role="tabpanel"
                        v-show="activeTab === 'driver'"
                    >
                        <driver-prop-detail :title="''" :options="selectedProperty" @closed="closeDetailModal" />
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal ref="totalRealModal" size="lg" :hide-footer="true" :title="$t('실시간 수집데이터 조회')">
            <total-real-popup :facility="facility" />
        </b-modal>
    </div>
</template>

<script>
import { Drop } from "vue-drag-drop";
import ValidInput from "@src/components/validate-input/Valid-Input.vue";
import * as rules from "@src/consts/ruleConsts.js";
import * as popupMessages from "@src/consts/popupMessageConsts";
import backEndApi from "@api/backEndApi.js";
import PointDetail from "@src/views/new/point-management/point-mgmt/PointDetail.vue";
import TotalRealPopup from "./TotalRealPopup.vue";
import DriverPropDetail from "@src/views/component/v2.1/DetailView/DriverPropDetail.vue";

export default {
    components: {
        Drop,
        ValidInput,
        PointDetail,
        TotalRealPopup,
        DriverPropDetail,
    },
    props: {
        facilityIdx: {
            type: [Number, String],
            default: null,
        },
        facility: {
            type: Object,
            default: null,
        },
        facilityMap: {
            type: Array,
            default: () => [],
        },
        hierarchy: {
            type: String,
            default: "",
        },
        parentFacilityName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            filterIO: "", // In, Out
            filterName: "", // 속성명, 관제점주소 두가지 조회.
            filterAddr: "Y", // ''=전체, 'Y'=주소있음, 'N'=주소없음
            curPage: 1, // 현재 페이지
            minPage: 1, // ??
            pageSize: 10, // 페이지 버튼의 갯수
            viewSize: 100, // 한페이지에 보여질 갯수
            perViews: [10, 100, 1000, 99999],
            updateMap: [], // 주소가 변경된 것들을 모아놓았다가 나중에 저장할때 사용.
            driverProps: [], // 드라이버 속성들
            localFacility: null, // 로컬 장비 정보 (prop 변경 방지)
            localFacilityMap: [], // 로컬 장비 맵핑 정보 (prop 변경 방지)
            rules,
            popupMessages,
            // 모달 관련 데이터
            ptIdx: null,
            selectedProperty: null, // 선택된 property 정보
            activeTab: "point", // 현재 활성화된 탭
        };
    },
    computed: {
        // hierarchy() {
        //     if (this.facility) {
        //         return this.facility.facilityName || "";
        //     }
        //     return "";
        // },
        filterMap() {
            let filterData = this.localFacilityMap || [];
            // In / Out 필터
            if (!this.isEmpty(this.filterIO))
                filterData = filterData.filter((v) => v.direction == this.filterIO || v.direction == "Both");

            // 관제점주소가 있는냐 없느냐임.  실제 관제점 주소가 할당된것과는 다름
            if (!this.isEmpty(this.filterAddr))
                filterData = filterData.filter(
                    (v) =>
                        (this.filterAddr == "Y" && !this.isEmpty(v.ptAddr)) ||
                        (this.filterAddr == "N" && this.isEmpty(v.ptAddr))
                );

            // 조회 문자열은 속성명과 관제점 주소..
            let filterName = this.filterName ? this.filterName.toLowerCase() : "";
            if (!this.isEmpty(this.filterName)) {
                filterData = filterData.filter(
                    (v) =>
                        v.propertyName &&
                        v.propertyName.toLowerCase &&
                        v.propertyName.toLowerCase().includes(filterName)
                );
            }

            return filterData;
        },
        // 현재 페이지에 표시되어야할 목록
        pagingMap() {
            if (!this.filterMap || !Array.isArray(this.filterMap)) return [];
            let s = this.viewSize * (this.curPage - 1);
            return this.filterMap.slice(s, s + this.viewSize);
        },
        // 페이징 최대 수
        maxPage() {
            if (!this.filterMap || !Array.isArray(this.filterMap)) return 1;
            let division = Math.floor(this.filterMap.length / this.viewSize);
            let remaining = this.filterMap.length % this.viewSize != 0 ? 1 : 0;

            return Math.max(1, division + remaining);
        },
        checkedCount() {
            if (!this.filterMap || !Array.isArray(this.filterMap)) return 0;
            return this.filterMap.filter((v) => v.isChecked).length;
        },
    },
    watch: {
        facilityIdx: {
            handler(newVal) {
                if (newVal) {
                    this.initPointMapping();
                }
            },
            immediate: true,
        },
        facility: {
            handler(newVal) {
                if (newVal && newVal.facilityIdx) {
                    // prop이 변경되면 로컬 데이터도 업데이트
                    this.localFacility = { ...newVal };
                    this.loadFacilityData();
                }
            },
            deep: true,
        },
        curPage() {
            // 페이지 이동시 선택 제거되어야 함..  보이지 않는 페이지에 선택된것이 남아 있으면, 저장이 되어 문제가 될 수 있다.
            this.pagingMap.forEach((v) => {
                v.isChecked = false;
            });
        },
    },
    mounted() {
        this.initPointMapping();
    },
    methods: {
        isEmpty(value) {
            return (
                value === null ||
                value === undefined ||
                value === "" ||
                (Array.isArray(value) && value.length === 0) ||
                (typeof value === "string" && value.trim() === "")
            );
        },
        rowSelect(row) {
            row.isChecked = !row.isChecked;
        },
        toggleAll() {
            let isAll = false;

            // 전체가 선택되어 있으면, 해제시킨다.
            let arr = this.pagingMap;
            if (arr.length == arr.filter((v) => v.isChecked).length) {
                isAll = false;
            } else {
                isAll = true;
            }

            this.pagingMap.forEach((v) => {
                v.isChecked = isAll;
            });
        },
        onClearAddr() {
            this.alertConfirmWarning(this.popupMessages.POINT_DATA_COLLECTION_MODULE_DELETE_POPUP_MESSAGE).then(
                (result) => {
                    if (!result.value) return;

                    this.localFacilityMap
                        .filter((v) => v.isChecked)
                        .forEach((prop) => {
                            prop.ptAddr = "";
                        });
                }
            );
        },
        onFillAddr() {
            this.alertConfirmWarning(this.popupMessages.POINT_DATA_COLLECTION_MODULE_ADD_POPUP_MESSAGE).then(
                (result) => {
                    if (!result.value) return;

                    this.localFacilityMap
                        .filter((v) => v.isChecked)
                        .forEach((prop) => {
                            prop.ptAddr = this.makeAutoPtAddr(prop);
                        });
                }
            );
        },
        makeAutoPtAddr(facProp) {
            //계측기명
            let meterType = this.localFacility ? this.localFacility.facilityAddr : "ETC";

            const namePrefix = this.parentFacilityName ? this.parentFacilityName : meterType;

            //관제점 주소
            let ptFullAddr = `${namePrefix}.${facProp.ct}.${facProp.propName}`.toUpperCase();

            // 생성된 값이 이전과 같지 않다면 업데이트에 추가
            if (facProp.ptAddr !== ptFullAddr) this.onChangeAddr(facProp);

            return ptFullAddr;
        },
        onChangeAddr(facProp) {
            // 기존 ptIdx가 존재해야 업데이트 항목임
            if (!this.isEmpty(facProp.ptIdx) && !this.isEmpty(facProp.ptAddr)) {
                let updateObj = this.updateMap.find((v) => v.ptIdx === facProp.ptIdx);

                // 기존값이 없는 경우
                if (this.isEmpty(updateObj)) {
                    this.updateMap.push({ ...facProp }); // 객체 복사본 추가
                } else {
                    // 기존 항목 업데이트
                    Object.assign(updateObj, facProp);
                }
            }
        },
        onSaveMap() {
            this.alertQuestion(this.popupMessages.POINT_DATA_COLLECTION_MODULE_SAVE_POPUP_MESSAGE).then(
                async (result) => {
                    if (!result.value) return;

                    // TODO : 트랜잭션 하나로 서비스 만들어야 함.
                    await this.deletePointAndFacilityMap();

                    await this.insertPointAndFacilityMap();

                    await this.updatePointAndFacilityMap();

                    this.alertNoti(this.popupMessages.COMMON_SAVE_POPUP_MESSAGE);
                    this.$emit("save-done");
                    this.initPointMapping();
                }
            );
        },
        beforePage() {
            this.curPage -= 1;

            if (this.minPage != 1 && this.curPage < this.minPage) this.minPage -= 1;
        },
        nextPage() {
            if (this.curPage < this.maxPage) {
                this.curPage += 1;

                if (this.curPage > this.minPage + this.pageSize - 1 && this.minPage + this.pageSize - 1 < this.maxPage)
                    this.minPage += 1;
            }
        },
        initPointMapping() {
            this.updateMap = [];
            this.curPage = 1;
            this.minPage = 1;
            this.filterIO = "";
            this.filterName = "";
            this.filterAddr = "Y";
            this.localFacility = null;
            this.localFacilityMap = [];
            // 모달 상태 초기화
            this.ptIdx = null;
            this.selectedProperty = null;
            this.activeTab = "point"; // 탭 초기화

            // facilityIdx가 있으면 데이터를 로드
            if (this.facilityIdx) {
                this.loadFacilityData();
            }
        },

        async loadFacilityData() {
            try {
                // 장비 정보 조회
                if (this.facilityIdx) {
                    const { data: facilityData } = await backEndApi.facility.getFacility(this.facilityIdx);
                    if (facilityData && !this.checkError(facilityData)) {
                        this.localFacility = facilityData;
                    }
                }

                // 장비 맵핑 정보 조회
                if (this.localFacility && this.localFacility.facilityIdx) {
                    const facilityMap = await this.searchFacilityMapWithPtAddr();
                    this.localFacilityMap = facilityMap;

                    // 드라이버 속성 조회
                    if (this.localFacility.driverType && this.localFacility.version) {
                        const driverProps = await this.getDriverProp();
                        this.driverProps = driverProps;

                        // 장비에 ct가 없을땐, 전체...
                        if (this.localFacility.ct) {
                            this.driverProps = this.driverProps.filter((v) => v.ct == this.localFacility.ct);
                        }

                        // 드라이버 속성목록을 기준으로 맵핑정보를 생성한다.
                        this.generateFacilityMap();
                    }
                }
            } catch (error) {
                console.error("Error loading facility data:", error);
            }
        },

        generateFacilityMap() {
            if (!this.driverProps || !this.localFacilityMap) return;

            let arr = this.driverProps.map((driverProp) => {
                let facProp = this.localFacilityMap.find(
                    (v) => v.direction === driverProp.direction && v.propertyName === driverProp.propertyName
                );

                let ptAddrText = null;
                if (facProp) ptAddrText = facProp.ptAddr && facProp.ptIdx ? `${facProp.ptAddr} (${facProp.ptIdx})` : "";

                return {
                    facilityIdx: this.localFacility.facilityIdx,
                    direction: driverProp.direction || "",
                    propertyName: driverProp.propertyName || "",
                    propName: driverProp.propName || "",
                    propAddr: facProp?.propAddr ?? null,
                    ct: driverProp.ct || 0,
                    ptIdx: facProp ? facProp.ptIdx : null,
                    ptAddr: facProp ? facProp.ptAddr : null,
                    ptAddrText: ptAddrText || "",
                    orgAddr: facProp ? facProp.ptAddr : null, // 변경여부 체크
                    driverType: driverProp.driverType || "",
                    version: driverProp.version || "",
                    ptType: driverProp.ptType || "",
                    remark: driverProp.remark || "-", // 기본값 설정
                    ptName: facProp ? facProp.ptName : null,
                    isChecked: false,
                };
            });

            this.localFacilityMap = arr;
        },

        async searchFacilityMapWithPtAddr() {
            if (!this.localFacility || !this.localFacility.facilityIdx) return [];

            try {
                const { data } = await backEndApi.facilityMap.searchFacilityMapWithPtAddr(
                    this.localFacility.facilityIdx
                );
                if (this.checkError(data)) return [];
                return data;
            } catch (error) {
                console.error("Error searching facility map:", error);
                return [];
            }
        },

        async getDriverProp() {
            if (!this.localFacility || !this.localFacility.driverType || !this.localFacility.version) return [];

            try {
                const { data } = await backEndApi.driver.getDriverProp(
                    this.localFacility.driverType,
                    this.localFacility.version
                );
                if (this.checkError(data)) return [];
                return data;
            } catch (error) {
                console.error("Error getting driver properties:", error);
                return [];
            }
        },

        checkError(data) {
            // $err 메서드가 없을 경우를 대비한 안전한 에러 체크
            if (this.$err) {
                return this.$err(data);
            }
            // 기본 에러 체크 로직
            return !data || data.error || data.status === "error";
        },
        onTotalRealPopup() {
            this.$refs.totalRealModal.show();
        },
        closeDetailModal() {
            this.$refs.detailModal.hide();
            this.ptIdx = null;
            this.selectedProperty = null;
        },
        dataUpdated() {
            // 포인트 데이터가 업데이트되었을 때 처리
            this.loadFacilityData();
        },
        handleBodyDragOver(data, event) {
            if (data.item.type === this.CODE?.Drag?.Point || data.item.type === this.CODE?.Drag?.PointGroup)
                event.dataTransfer.dropEffect = "move";
            else event.dataTransfer.dropEffect = "none";
        },
        handleBodyDrop(transfer, dragEvent) {
            this.$emit("body-drop", transfer, dragEvent);
        },
        openDetailModal(property) {
            this.ptIdx = property.ptIdx;
            this.selectedProperty = property; // 선택된 property 정보 저장

            // ptIdx가 없으면 자동으로 driver 탭을 활성화
            if (!property.ptIdx) {
                this.activeTab = "driver";
            } else {
                this.activeTab = "point";
            }

            this.$refs.detailModal.show();
        },
        // ===== 관제점 CRUD 작업 메서드 =====

        // 생성된 관제점 저장
        async insertPointAndFacilityMap() {
            const insertMap = this.prepareInsertMap();
            if (insertMap.length === 0) return null;

            try {
                const { data } = await backEndApi.pointInfo.insertPointAndFacilityMap(insertMap);
                return this.handleApiResponse(data, "insert");
            } catch (error) {
                console.error("관제점 생성 실패:", error);
                return null;
            }
        },

        // 변경된 관제점 업데이트
        async updatePointAndFacilityMap() {
            const updateMap = this.prepareUpdateMap();
            if (updateMap.length === 0) return null;

            try {
                const { data } = await backEndApi.pointInfo.updatePointAndFacilityMap(updateMap);
                return this.handleApiResponse(data, "update", updateMap);
            } catch (error) {
                console.error("관제점 업데이트 실패:", error);
                return null;
            }
        },

        // 제거된 관제점 삭제
        async deletePointAndFacilityMap() {
            const deleteMap = this.prepareDeleteMap();
            if (deleteMap.length === 0) return null;

            try {
                const { data } = await backEndApi.pointInfo.deletePointAndFacilityMap(deleteMap);
                return this.handleApiResponse(data, "delete");
            } catch (error) {
                console.error("관제점 삭제 실패:", error);
                return null;
            }
        },

        // ===== 데이터 준비 메서드 =====

        // 삽입할 데이터 준비
        prepareInsertMap() {
            return this.localFacilityMap
                .filter((item) => this.isValidForInsert(item))
                .map((item) => this.createInsertData(item))
                .filter(Boolean);
        },

        // 업데이트할 데이터 준비
        prepareUpdateMap() {
            return this.updateMap.map((update) => this.createUpdateData(update)).filter(Boolean);
        },

        // 삭제할 데이터 준비
        prepareDeleteMap() {
            return this.localFacilityMap
                .filter((item) => this.isValidForDelete(item))
                .map((item) => item.ptIdx)
                .filter(Boolean);
        },

        // ===== 유효성 검사 메서드 =====

        // 삽입 유효성 검사
        isValidForInsert(item) {
            return item.isChecked && this.isEmpty(item.ptIdx) && !this.isEmpty(item.ptAddr);
        },

        // 삭제 유효성 검사
        isValidForDelete(item) {
            return item.isChecked && !this.isEmpty(item.ptIdx) && this.isEmpty(item.ptAddr);
        },

        // ===== 데이터 생성 메서드 =====

        // 삽입 데이터 생성
        createInsertData(insert) {
            const prop = this.findDriverProperty(insert);
            if (!prop) return null;

            const meterInfo = this.getMeterInfo();

            return {
                meterTypeCode: meterInfo.meterTypeCode,
                pt: this.createPointData(insert, prop, meterInfo.meterType),
                facilityMap: this.createFacilityMapData(insert),
            };
        },

        // 업데이트 데이터 생성
        createUpdateData(update) {
            const facProp = this.findFacilityProperty(update);
            if (!facProp) return null;

            const drvProp = this.findDriverProperty(update);
            if (!drvProp) return null;

            return {
                ptIdx: update.ptIdx,
                ptAddr: update.ptAddr,
            };
        },

        // ===== 헬퍼 메서드 =====

        // 드라이버 속성 찾기
        findDriverProperty(item) {
            return this.driverProps.find(
                (prop) => prop.direction === item.direction && prop.propertyName === item.propertyName
            );
        },

        // 장비 속성 찾기
        findFacilityProperty(update) {
            return this.localFacilityMap.find((item) => item.isChecked && item.ptIdx && item.ptIdx === update.ptIdx);
        },

        // 계측기 정보 가져오기
        getMeterInfo() {
            const meterType = this.parent?.facilityName || this.facility?.facilityName || "ETC";
            const meterTypeCode = this.parent?.meterTypeCode || this.facility?.meterTypeCode || "";

            return { meterType, meterTypeCode };
        },

        // 포인트 데이터 생성
        createPointData(insert, prop, meterType) {
            return {
                ptGroup: prop.isVirtual ? "Virtual" : meterType.toUpperCase(),
                ptAddr: insert.ptAddr,
                ptName: `${this.parent?.facilityAlias || ""}/${this.facility?.facilityAlias || ""}/${prop.propName}`,
                ptTypeCode: prop.ptType?.toUpperCase() || "",
                filterMinValue: prop.min,
                filterMaxValue: prop.max,
                itemUseageCode: this.facility?.usageCode,
                energySourceCode: this.facility?.energySourceCode,
                energySplyTypeCode: this.facility?.energySplyTypeCode,
                applyZoneIdx: this.facility?.applyZoneIdx,
                unitLargeCode: prop.unitType,
                unitSmallCode: prop.unit,
                overFlowValue: null,
                isCov: 0,
                uplLogic: null,
                isVirtual: prop.isVirtual,
                valueType: prop.valueType,
                mappingKey: this.facility?.mappingKey,
            };
        },

        // 장비 맵핑 데이터 생성
        createFacilityMapData(insert) {
            return {
                facilityIdx: this.facility?.facilityIdx,
                direction: insert.direction,
                propertyName: insert.propertyName,
                ptIdx: null,
            };
        },

        // API 응답 처리
        handleApiResponse(data, operation, updateMap = null) {
            if (this.$err && this.$err(data)) {
                console.error(`API ${operation} 실패:`, data);
                return null;
            }

            // 업데이트 후 updateMap 정리
            if (operation === "update" && updateMap) {
                this.cleanupUpdateMap(updateMap);
            }

            return data;
        },

        // 업데이트 맵 정리
        cleanupUpdateMap(updateMap) {
            this.updateMap = this.updateMap.filter((item) => {
                const match = updateMap.find((update) => update.ptIdx === item.ptIdx);
                return !match; // 성공적으로 업데이트된 항목 제거
            });
        },

        onInputClick(event) {
            // input 클릭 시 이벤트 전파를 막아서 모달이 열리지 않도록 함
            event.stopPropagation();
        },
    },
};
</script>

<style scoped>
.checkbox.checkbox-css label:before {
    display: none;
}

.facilityMap-table-div {
    overflow-y: scroll;
    max-height: 500px;
}

.addr-control {
    height: calc(1em + 14px + 2px);
    padding: 2px 0.75rem;
}

.checkbox.checkbox-css input {
    display: block;
}

.title {
    font-size: 14px;
    font-weight: 600;
    margin-left: 10px;
    margin-right: 10px;
}

.badge {
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
    display: inline-block;
    min-width: 20px;
    padding: 0px 10px 0px 10px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    line-height: 22px;
    border-radius: 8px;
}

.badge.id {
    background-color: #ff6d00;
    color: #fff;
}

.badge.title {
    background-color: #546e7a;
    color: #fff;
}

.badge.option {
    background-color: #cfd8dc;
    color: #000;
}

.detail-tabs {
    padding: 5px;
}

.detail-tabs .nav-tabs .nav-link {
    border: none;
    color: #6c757d;
    font-weight: 500;
    padding: 12px 20px;
    margin-right: 5px;
    border-radius: 8px 8px 0 0;
    transition: all 0.3s ease;
    border-bottom: 2px solid transparent;
}

.detail-tabs .nav-tabs .nav-link:hover {
    color: #495057;
    background-color: #f8f9fa;
    border-color: transparent;
}

.detail-tabs .nav-tabs .nav-link.active {
    /* color: #007bff; */
    background-color: #fff;
    border-bottom: 2px solid #007bff;
    font-weight: 600;
}

.detail-tabs .point-mapping-modal-tab-content {
    height: 80vh;
}

.detail-tabs .tab-pane {
    display: none;
    height: 100%;
}

.detail-tabs .tab-pane.show {
    display: block;
}

.detail-tabs .tab-pane.active {
    display: block;
}

/* 행 호버 효과 */
.table tbody tr:hover {
    background-color: #f8f9fa;
    transition: background-color 0.2s ease;
}

/* 체크박스 클릭 시 이벤트 전파 방지 */
.checkbox.checkbox-css {
    pointer-events: auto;
}
</style>
